import {css} from '@emotion/core'
import SupplyUltraLight from '../fonts/Supply-UltraLight.woff'
import SupplyLight from '../fonts/Supply-Light.woff'
import AktivGroteskBold from '../fonts/AktivGroteskBold.woff'
import vars from './vars'

const global = css`
    @font-face {
        font-family: 'Supply';
        src: url('${SupplyUltraLight}') format('woff');
        font-weight: 100;
    }

    @font-face {
        font-family: 'Supply';
        src: url('${SupplyLight}') format('woff');
        font-weight: 200;
    }

    @font-face {
        font-family: 'Aktiv Grotesk';
        src: url('${AktivGroteskBold}') format('woff');
        font-weight: 600;
    }

    html {
        font-size: 62.5%;
    }

    body {
        font-family: ${vars.bodyFontFamily};
        font-size: 1.5rem;
        font-weight: 200;
        line-height: 1.6;
        margin: 0;
    }

    h1,
    h2,
    h3,
    h4,
    h5 {
        font-family: ${vars.headingsFontFamily};
        font-weight: 600;
        margin-top: 0;
        margin-bottom: 2rem;
    }

    h1 {
        font-size: 4rem;
        line-height: 1.2;
        letter-spacing: -0.1rem;
    }

    h2 {
        font-size: 3.6rem;
        line-height: 1.25;
        letter-spacing: -0.1rem;
    }

    h3 {
        font-size: 3rem;
        line-height: 1.3;
        letter-spacing: -0.1rem;
    }

    h4 {
        font-size: 2.4rem;
        line-height: 1.35;
        letter-spacing: -0.08rem;
    }

    h5 {
        font-size: 1.8rem;
        line-height: 1.5;
        letter-spacing: -0.05rem;
    }

    h6 {
        font-size: 1.5rem;
        line-height: 1.6;
        letter-spacing: 0;
    }

    @media (min-width: 550px) {
        h1 {
            font-size: 5rem;
        }

        h2 {
            font-size: 4.2rem;
        }

        h3 {
            font-size: 3.6rem;
        }

        h4 {
            font-size: 3rem;
        }

        h5 {
            font-size: 2.4rem;
        }

        h6 {
            font-size: 1.5rem;
        }
    }

    p {
        margin-top: 0;
    }

    input,
    textarea,
    select,
    fieldset {
        margin-bottom: 1.5rem;
    }

    pre,
    blockquote,
    dl,
    figure,
    table,
    p,
    ul,
    ol,
    form {
        margin-bottom: 2.5rem;
    }

    fieldset {
        legend {
            font-family: ${vars.headingsFontFamily};
        }

        label {
            font-weight: 200;
        }
    }

    input {
        &[type='email'],
        &[type='number'],
        &[type='search'],
        &[type='text'],
        &[type='tel'],
        &[type='url'],
        &[type='password'] {
            appearance: none;
        }

        &[type='checkbox'],
        &[type='radio'] {
            display: inline;
        }

        &[type='email']:focus,
        &[type='number']:focus,
        &[type='search']:focus,
        &[type='text']:focus,
        &[type='tel']:focus,
        &[type='url']:focus,
        &[type='password']:focus {
            outline: 0;
        }

        font-weight: 200;
        height: 38px;
        padding: 6px 10px;
        background-color: #fff;
        border: 1px solid ${vars.black};
        border-radius: 4px;
        box-shadow: none;
        box-sizing: border-box;
    }

    textarea {
        appearance: none;
        min-height: 65px;
        padding-top: 6px;
        padding-bottom: 6px;
        font-weight: 200;

        &:focus {
            outline: 0;
        }
    }

    label,
    legend {
        display: block;
        margin-bottom: 0.5rem;
        font-weight: 600;
    }

    fieldset {
        padding: 0;
        border-width: 0;
    }

    ul {
        list-style: circle inside;
        padding-left: 0;
        margin-top: 0;

        ul,
        ol {
            margin: 1.5rem 0 1.5rem 3rem;
            font-size: 90%;
        }
    }

    ol {
        list-style: decimal inside;
        padding-left: 0;
        margin-top: 0;

        ol,
        ul {
            margin: 1.5rem 0 1.5rem 3rem;
            font-size: 90%;
        }
    }

    li {
        margin-bottom: 1rem;
    }

    hr {
        margin: 4rem 0;
        border: none;
        border-bottom: 1px solid ${vars.black};
    }

    .icon {
        display: inline-block;
        fill: currentColor;
        height: 1em;
        stroke: currentColor;
        stroke-width: 0;
        width: 1em;
    }
`

export default global
